<template>
  <span v-if="label" class="pb-lock"><i class="mdi mdi-lock-outline" aria-hidden="true"></i><span class="pb-sr-only">Available on </span>{{ label }}</span>
</template>

<script>
import { planLabel } from '../lib/plans';

// The one lock mark: a lock and the plan that includes the feature, read as "Available on Agency".
export default {
  name: 'PlanChip',
  props: { plan: { type: String, default: '' } },
  computed: {
    label() { return this.plan ? planLabel(this.$store.getters['praiseboard/planMatrix'], this.plan) : ''; }
  }
};
</script>
